const explosions = ([
  {
    name: 'player',
    color:
      [
        0xffffff,
        0xffff00,
        0xff0000,
        0xffffff,
        0xffff00,
      ],
    coords: [
      [
        { x: 0.5, y: 0.8 }, { x: 0.5966, y: 0.8819 },
        { x: 0.6112, y: 0.7561 }, { x: 0.7898, y: 0.8527 },
        { x: 0.7862, y: 0.7707 },
      ],
      [
        {x: 0.7862, y: 0.7707}, {x: 0.8555, y: 0.7287},
        {x: 0.7, y: 0.5}, {x: 0.9156, y: 0.4480},
        {x: 0.5984, y: 0.3313}, {x: 0.7461, y: 0.0943}
      ],
      [
        {x: 0.7461, y: 0.0943}, {x: 0.4963, y: 0.1727},
        {x: 0.4726, y: 0.0524}, {x: 0.3869, y: 0.2110},
        {x: 0.2575, y: 0.048}
      ],
      [
        {x: 0.2575, y: 0.048}, {x: 0.2192, y: 0.2110},
        {x: 0.0606, y: 0.1964}, {x: 0.1828, y: 0.4097},
        {x: 0.0879, y: 0.4480}
      ],
      [
        {x: 0.0879, y: 0.4480}, {x: 0.1791, y: 0.5391},
        {x: 0.0879, y: 0.6850}, {x: 0.3651, y: 0.6412},
        {x: 0.3505, y: 0.90379}, {x: 0.5, y: 0.8},
      ],
    ]
  },
  {
    name: 'enemy',
    color:
      [
        0xffffff,
        0xffffff,
        0xffffff,
        0xffffff,
        0xffffff,
        0xffffff,
        0xffffff,
        0xffffff,
      ],
    coords: [
      [
        {x: 0.1, y: 0.5}, {x: 0.9, y: 0.5},
      ],
      [
        {x: 0.1280, y: 0.3528}, {x: 0.8696, y: 0.6527},
      ],
      [
        {x: 0.2174, y: 0.2168}, {x: 0.7814, y: 0.7842},
      ],
      [
        {x: 0.3350, y: 0.1356}, {x: 0.6670, y: 0.8634},
      ],
      [
        {x: 0.5, y: 0.1}, {x: 0.5, y: 0.9},
      ],
      [
        {x: 0.6728, y: 0.1392}, {x: 0.3311, y: 0.8626},
      ],
      [
        {x: 0.7851, y: 0.2194}, {x: 0.2168, y: 0.7825},
      ],
      [
        {x: 0.8653, y: 0.3371}, {x: 0.1361, y: 0.6661},
      ],
    ]
  },
]);

export default explosions;
